import { render, staticRenderFns } from "./ResetPasswordConfirm.vue?vue&type=template&id=926dbf44&scoped=true"
import script from "./ResetPasswordConfirm.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordConfirm.vue?vue&type=script&lang=ts"
import style0 from "./ResetPasswordConfirm.vue?vue&type=style&index=0&id=926dbf44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926dbf44",
  null
  
)

export default component.exports